<template>
    <page-common type="normal" :showAppTopLink="isSharePage" :showAppBotLink="isSharePage" :detail="data">
        <div class="wrapper">
            <div class="wrap" >
                <div v-if="data.type==='video'" ref="videoWrap"></div>
                <!-- <div class="video-mask" v-if="openVideoMask"></div> -->
                <p class="video-wrap"  v-if="data.type==='video'">
                    <video :src="videoUrl" :poster="poster" webkit-playsinline="true" playsinline="true" x5-playsinline="true" x-webkit-airplay="allow"  controlsList="nodownload"></video>
                    <button class="content-button"></button>
                </p>
                <!-- <div class="box-block" v-if="data.type==='video'"></div> -->
                <!-- <audio v-else-if="data.type==='audio' && isSharePage" :src="audioUrl" controls></audio> -->
                <audioBar
                    :src="audioUrl"
                    v-else-if="data.type==='audio' && isSharePage"
                    :totalTimes="totalTimes"
                ></audioBar>
                <!-- <div class="top-pic" v-else  v-show="imageUrl">
                    <img :src="imageUrl" alt="">
                </div> -->
                <div class="essay">
                    <!-- <h3 v-if="$route.params.type !== 'normal'">{{data.introTitle?data.introTitle:''}}</h3> -->
                    <h3 v-if="data.introTitle" v-html="data.introTitle"></h3>
                    <h1 v-if="data.title" v-html="data.title"></h1>
                    <div class="desc"  v-if="data.subTitle" v-html="data.subTitle"></div>
                    <template v-if="$route.params.type === 'normal'">
                        <!-- 栏目专用 -->
                        <template v-if="data.categoryInfo && data.categoryInfo.parentId > 1">
                            <div class="category-info flex-default" >
                                <div class="flex flex-cross-center">
                                    <img class="avatar" :src="data.categoryInfo.image" alt="" onerror>
                                    <div class="info">
                                        <h5>{{data.categoryInfo.name}}</h5>
                                        <div class="date mult_line_ellipsis">{{data.categoryInfo.description}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="date-wrap flex flex-cross-center">
                                <div class="date">{{date}}</div>
                            </div>
                        </template>
                        <div class="date-wrap flex flex-cross-center" v-else>
                            <!-- <div class="recite" v-if="isVoice && !isSharePage" @click="readPaper"></div> -->
                            <div class="date">{{date}} {{source}} {{data.authors}}</div>
                        </div>
                    </template>
                    <!-- 政务专用 -->
                    <template  v-if="data.sysCode === 'gov'">
                        <template v-if="data.orgInfo">
                            <div class="gov-info flex-default">
                                <div class="flex flex-cross-center" @click="goGov">
                                    <img class="avatar" :src="data.orgInfo.logo" alt="" onerror>
                                    <div class="info">
                                        <h5><div class="line_ellipsis">{{data.orgInfo.name}}</div><span class="title-icon">锦观号</span></h5>
                                        <div class="date  mult_line_ellipsis">{{data.orgInfo.introduction}}</div>
                                    </div>
                                </div>
                                <div v-if="!isSharePage && (isFollow===1 || isFollow===0)" :class="['follow-btn', isFollow?'no':'']" @click="setFollow">
                                    {{isFollow?'已订阅':'+订阅'}}
                                </div>
                            </div> 
                            <div class="date-wrap flex flex-cross-center">
                                <div class="date">{{date}} {{source}} {{data.authors}}</div>
                            </div> 
                        </template>
                        <div class="date-wrap flex flex-cross-center" v-else>
                            <!-- <div class="recite" v-if="isVoice && !isSharePage" @click="readPaper"></div> -->
                            <div class="date">{{date}} {{source}} {{data.authors}}</div>
                        </div>
                    </template>
                    <template   v-if="$route.params.type === 'paper'">
                        <div class="date-wrap flex flex-cross-center">
                            <!-- <div class="recite" v-if="isVoice && !isSharePage" @click="readPaper"></div> -->
                            <div class="date">{{date}} {{source}} {{data.authors}}</div>
                        </div>
                    </template>
                </div>
                
                <ul class="images" v-if="$route.params.type === 'paper'">
                    <li v-for="item in data.imgall">
                        <img v-lazy="item.imgUrl" alt="" />
                    </li>
                </ul>
                <div ref="content" :class="['content',!isSharePage ? 'font-size-'+fontSizeNum : 'font-size-4']" v-html="data.content?data.content:''"></div>
                <PageVote v-if="data.hasVote" :voteObj="data"></PageVote>
                <!-- 锦观 -->
                <div class="content-footer"></div>
                <!-- 相关信息 -->
                <ul class="article-desc">
                    <li>未经授权，严禁转载</li>
                    <li>联系电话：028-86751128</li>
                </ul>
                <!-- 文章点赞 -->
                <div v-if="isSharePage && ($route.params.type === 'paper'|| $route.params.type === 'normal'||data.sysCode === 'gov')" @click="uuid" :class="[isLike?'active-good uuidLikes flex flex-cross-center':'uuidLikes like flex flex-cross-center']">
                    <!-- {{getLikesCount(likes)}}赞 -->
                    <i :class="[isLike?'active-good':'good']"></i>
                    <span :class="[isLike?'active-num':'num']">{{likes<=0?'赞':getLikesCount(likes)}}</span>
                     
                </div>
                <!-- 相关推荐 -->
                <div class="relevant-news" v-if="relvantNewsData.length>0">
                    <div class="title">
                        大家都在看
                    </div>
                    <list v-bind:relvantNewsData="relvantNewsData"></list>
                </div>
                <div class="comment" v-if="comments !== null">
                    <div class="title" v-if="comments.length > 0">
                        <i></i>
                        <span>热门评论</span>
                    </div>
                    <div v-if="comments.length > 0">
                        <ul>
                            <li :key="index" v-for="(item, index) in comments" @click="addComment(item)">
                                <header class="flex flex-cross-center flex-main-justify">
                                    <div class="flex flex-cross-center">
                                        <div class="avatar" :style="{backgroundImage:`url(${item.userIcon?item.userIcon:icon})`}"></div>
                                        <div class="info-area">
                                            <div class="name ellipsis">{{item.username}}</div>
                                            <div class="time ellipsis">{{getTime(item.date)}}</div>
                                        </div>
                                    </div>
                                    <div class="like flex flex-cross-center" @click.stop="setActiveLike(item)">
                                        <span :class="[item.isLike?'active-num':'num']">{{getLikesCount(item.likes+'')}}</span>
                                        <i :class="[item.isLike?'active-good':'good']"></i>
                                    </div>
                                </header>
                                <section>
                                    <p v-html="item.content"></p>
                                </section>
                                <div class="origin" v-if="item.parent">
                                    <div class="origin-info flex flex-cross-center flex-main-justify">
                                        <div class="origin-name">{{item.parent.username}}</div>
                                        <!-- <div class="origin-time">{{getTime(item.parent.date)}}</div> -->
                                    </div>
                                    <div class="origin-content">
                                        {{item.parent.content}}
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <div v-if="!isSharePage" class="check-all" @click="appPostMessage('checkAllComment')">查看全部评论 <i></i></div>
                    </div>
                    
                    <!-- <div class="check-all" >查看全部评论 <i></i></div> -->
                    <!-- <div v-else class="no-comment"></div> -->
                </div>
            </div>
            <div class="largeSwiper" v-if="showLargeImage" >
                <div class="viewSwiper" @click="closeLargeImage" @touchmove.prevent>
                    <div class="swiper-container">
                    <div class="swiper-wrapper ">
                        <div class="swiper-slide swiper-zoom-container" v-for="(item, index) of newImages" :key="index">
                            <img :src="item" />
                            
                        </div>
                    </div>
                 </div>
                </div>
                
                <div class="swiper-pagination"></div>
            </div>
        </div>
      
    </page-common>
</template>

<script>
import Vue from 'vue'
import { Lazyload, MessageBox, Toast } from 'mint-ui';
import api from 'src/constants/appapi'
import PageCommon from './page-common'
import PageVote from './page-vote.vue'
import { intfc_prefix_common, govUrl } from 'constants/project'
import icon from 'src/images/icon_user_default_avatar.png'
import List from "./com-list";
import audioBar from "./com-audio-bar";
import wx from "../services/weChatShare"
import Swiper from "swiper/dist/js/swiper.js";
import { v4 as uuidv4 } from 'uuid';
Vue.use(Lazyload);
export default {
    data () {
        return {
            icon,
            isSharePage: false, // 是否为分享页面
            el: null, // 元素：正在播放的video
            data: {}, // 接口数据
            type: '', // 文章类型
            videoUrl: '', // 顶部video的地址
            audioUrl: '', // 顶部audio的地址
            imageUrl: '', // 顶部img的地址
            isVoice: false, // 是否可以朗读
            content: '', // 接口：内容部分
            poster: '', // 顶部video的图片
            date: '', // 日期
            fontSizeNum: 3, // 字体设置大小  1-5 小-大
            source: '', // 作品来源
            urls: [], // 文章内所以图片合集
            comments: null, // 评论内容
            mockLikes: [], // 点赞数组
            images: [], // content内的图片
            saveVideo: null, // 4g/wifi 弹窗前保存的video元素
            picFlag: true, // 图集flag防止连续点击
            openVideoMask: false, //video的黑色底部
            relvantNewsData: [],
            isFollow: null, // 政务gov 是否关注
            totalTimes: "",
            isPreviewPage:false,
            newImages:[],
            showLargeImage:false,
            showLargeIndex:0,
            mySwiper:'',
            slideTo:'',
            vodeOption:{},
            isShowDialog: false,
            dialogParams:{},
            uuids:0,
            likes:0, //点赞数
            isLike:false,
        }
    },

	created () {
        // 暴露方法给webview
        window.appapi = api
        window.$vm = this
        // 设置字体大小
        appapi.changeFontSize(this.$route.query.fontsize)
        this.isPreviewPage = appapi.isPreviewPage()
        // 判断 普通或报纸 调取不同的接口
        if (this.$route.params.type === 'paper') {
            this.initPaper(this.$route.params.id)
        }else if (this.$route.params.type === 'normal') {
            this.initNormal(this.$route.params.id)
        }else if (this.$route.params.type === 'gov') {
            this.initGov(this.$route.params.id)
        }

        this.isSharePage = appapi.isSharePage()
        // console.log(typeof uuidv4(),'uuidv4();uuidv4();uuidv4();')
        this.uuids = localStorage.getItem('uuid');
        if (!this.uuids) {
            localStorage.setItem('uuid',uuidv4());
        }

        console.log(this.uuids,'初次uuids')
	},

    mounted () {
        this.move()
         
        
    },

    updated () {
        let imgs = $('.content img')
        this.images = Array.from(imgs)
        this.$nextTick(function() {
            this.mySwiper = new Swiper(".largeSwiper .swiper-container", {
                pagination:{
                    el:'.swiper-pagination',
                    clickable:true,
                    type : 'fraction'
                },
                
                initialSlide :this.showLargeIndex,
                speed: 500,
                zoom : true, //开启缩放功能
                loop: this.newImages.length>1?true:false,
                autoHeight: true,
                autoplayDisableOnInteraction: false,
                paginationCustomRender: function(swiper, current, total) {
                return current + " / " + total;
                }
            });
            // console.log(this.showLargeIndex,'index')
            // this.mySwiper.slideTo(this.showLargeIndex)
            //console.log(this.slideTo,this.mySwiper.slideTo,"this.mySwiper")
    
        });
    },
    beforeDestroy() {
        // this.mySwiper.destroy();
    },

    watch: {
        '$route' (to, from) { //监听路由是否变化
            if(to.params.id != from.params.id){
                // console.log("123")
                if (this.$route.params.type === 'paper') {
                    this.initPaper(this.$route.params.id)
                }else if (this.$route.params.type === 'normal') {
                    this.initNormal(this.$route.params.id)
                }else if (this.$route.params.type === 'gov') {
                    this.initGov(this.$route.params.id)
                }
            }
        },
        data: {
            handler (val) {           
                // this.$store.dispatch('setShowPage', true)

                if (this.isSharePage) {
                    // 微信分享
                    const imgUrl = val.images?val.images[0]:'';
                    const cover = val.cover || ''
                    wx({
                        title: val.title,
                        // imgUrl: imgUrl || cover || '',
                        // desc: val.description || ''
                    },this)

                }
                
                // 存储唤醒的数据
                // this.$store.dispatch('saveData', val)
                // content样式重绘
                this.pageUpdate()
            },
            deep: true
        },
        el: {
            handler (val, oldVal) {
                if (oldVal) {
                    let father = $(oldVal).parent()
                    father
                        .css('position', 'relative')
                    $(oldVal)
                        .css('position', 'absolute')
                        .css('z-index', 1)
                }
            },
            deep: true
        },
        comments: {
            handler () {},
            deep: true
        }
    },

	methods: {
        closeLargeImage(){
            
           this.showLargeImage=false
        },
        readPaper () {
            this.pauseAllVideo()
            this.appPostMessage('voiceRead')
        },
        setFollow () {
            if (!this.isFollow) {
                this.appPostMessage('sub')
            }else {
                this.goGov();
            }
        },
        goGov () {
            if (this.isSharePage) {
                if (this.data.orgInfo.type == '1') {
                    this.$router.push({name:'Local', params:{id:this.data.orgInfo.id}})
                } 
            } else {
                this.appPostMessage('goGovDetail')
            }
        },
        // handleScroll () {
        //     if (this.el) {
        //         let val = parseInt($(this.el).parent()[0].getBoundingClientRect().top)
        //         let height = document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight
        //         let father = $(this.el).parent()
        //         let scrollTop = $(document).scrollTop()
        //         if (this.isSharePage) {
        //             if(val > height && scrollTop<=100) {
        //                 father
        //                     .css('position', '')
        //                 $(this.el)
        //                     .css('position', 'absolute')
        //                     .css('top', 0)
        //                     .css('z-index', 1001)
        //                 // 非顶部视频悬浮时 打开黑色遮罩
        //                 this.openVideoMask = true
        //             }else if (val < 0 || val > height) {
        //                 father
        //                     .css('position', '')
        //                 $(this.el)
        //                     .css('position', 'fixed')
        //                     .css('top', 0)
        //                     .css('z-index', 1001)
        //                 // 非顶部视频悬浮时 打开黑色遮罩
        //                 this.openVideoMask = true
        //             }else {
        //                 father
        //                     .css('position', 'relative')
        //                 $(this.el)
        //                     .css('position', 'absolute')
        //                     .css('z-index', 1)
        //                 // 非顶部视频悬浮时 关闭黑色遮罩
        //                 this.openVideoMask = false
        //             }
        //         }else {
        //             if (val < 0 || val > height) {
        //                 father
        //                     .css('position', '')
        //                 $(this.el)
        //                     .css('position', 'fixed')
        //                     .css('top', 0)
        //                     .css('z-index', 1001)
        //                 // 非顶部视频悬浮时 打开黑色遮罩
        //                 this.openVideoMask = true
        //             }else {
        //                 father
        //                     .css('position', 'relative')
        //                 $(this.el)
        //                     .css('position', 'absolute')
        //                     .css('z-index', 1)
        //                  // 非顶部视频悬浮时 关闭黑色遮罩
        //                 this.openVideoMask = false
        //             }
        //         }
        //     }

        // },

        move () {
            // 滚动时懒加载 content内的图片,端内不做懒加载
            // this.getTopVideo()
            window.onload = window.onscroll = () => {
                // this.lazyLoad();
                // this.handleScroll()
                // if (this.data && (this.data.type === 'video')) {
                //     this.getTopVideo()
                // }
            }
        },

        initGov (id)  {
            // 政务接口
            // this.$axios.get(`${govUrl}/api/articles/${id}/detail`)
            this.$axios.get(`${govUrl}/api/v2/articles/info/${id}`)
                .then(res=> {
                    const result = res.data
                    if (res.code === 0) {
                        this.likes=result.likes
                        // console.log(result);
                        // this.data = result
                        // if (this.data.content.indexOf('<p') === -1) {
                        //     this.data.content = `<p>${result.content}<p>`
                        // }

                        // this.source = result.copyfrom
                        // // this.date = result.newsDatetime
                        // this.date = result.date.substring(0,10) + ' ' + result.date.substring(11,16)
                        // this.isVoice = result.isVoice?result.isVoice:false
                        if(result.delFlag === '1' || result.delFlag === '3'){
                            Toast("请求文章不存在或已下线");
                            return
                        }
                        if (result.type === "link") {
                            window.location.href = result.link;
                            return false;
                        } else if (result.type === "image") {
                            this.articleType = "image";
                            this.data = result;
                            this.data.medias = result.mediaList;
                            let obj = this.data.medias[0];
                            this.swipeDescription = obj.description || "";
                            this.data.content = "";
                            return false;
                        } else {
                            this.data = result;
                            let reg = new RegExp(/line-height:\s.*?[\d]*/g);
                            this.data.content = this.data.content
                                ? this.data.content.replace(
                                      reg,
                                      "line-height: ''"
                                  )
                                : "";
                            let textreg = new RegExp(
                                /text-indent:\s.*?(\d{2}pt)/g
                            );
                            this.data.content = this.data.content
                                ? this.data.content.replace(
                                      textreg,
                                      "text-indent:2em"
                                  )
                                : "";

                            this.imageUrl = result.images
                                ? result.images[0]
                                : "";

                            this.isVoice = result.isVoice
                                ? result.isVoice
                                : false;
                            this.source = result.copyfrom;
                            this.date = result.date.substring(0,10) + ' ' + result.date.substring(11,16)

                            if (result.type === "video") {
                                this.poster = result.image;
                                this.videoUrl = result.mediaList[0].image;
                            }
                            if (result.type === "audio") {
                                this.poster = result.image;
                                this.audioUrl = result.mediaList[0].image +'?_t='+Date.parse(new Date());
                                this.totalTimes = result.mediaList[0].times;
                            }
                        }
                        this.getHotList(result.categoryId,result.articleId)
                        this.getComment(result.sysCode, id)
                        // 原生app 渲染完调用
                        this.appPostMessage('renderFinish')
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        },

        initPaper (id)  {
            // 报纸接口
            this.$axios.get(`${intfc_prefix_common}/api/v2/paper/detail?articleId=${id}&platform=${appapi.checkTerminal()}`)
                .then(res=> {
                    const result = res.item
                    if (res.code === 0) {
                        // console.log(result);
                        this.data = result
                        this.likes=result.likes
                        this.source = result.copyfrom
                        this.date = result.newsDatetime
                        if (result.imgall && result.imgall.length > 0) {
                            result.imgall.map((item,index) => {
                                // console.log(item.imgUrl);
                                this.urls.push(item.imgUrl)
                            })
                        }
                        // 原生app 渲染完调用
                        this.appPostMessage('renderFinish')
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        },

        initNormal (id)  {
            let query = this.$route.query;
            let isTimeLimit = query.isTimeLimit;
            let articleUrl = `${intfc_prefix_common}/api/v2/articles/detail/`;
            if (!!isTimeLimit) {
                articleUrl = `${intfc_prefix_common}/api/v2/articles/detailPreview/`;
            }
            // 普通接口
            this.$axios.get(`${articleUrl}${id}`)
                .then(res=> {
                    const result = res.item
                    if (res.code === 0) {
                        this.likes=result.likes
                        // console.log(result,'1111111');
                        // 相关推荐
                        // if (result && result.recommondArticle) {
                        //     this.relvantNewsData = result.recommondArticle.map(
                        //         i => {
                        //             if (i.imageUrl) {
                        //                 if (i.imageUrl.indexOf(",") != -1) {
                        //                     i.imageUrl = i.imageUrl.split(",");
                        //                 } else {
                        //                     i.imageUrl = [i.imageUrl];
                        //                 }
                        //             }
                        //             return i;
                        //         }
                        //     );
                        // }
                        // 如果type为链接link 直接跳转
                        if (result.type === 'link') {
                            window.location.href = result.link
                            return false
                        }

                        this.data = result
                        //if(this.data.hasVote){
                           // this.getVote(this.data.voteId||'')
                       // }
                        this.imageUrl = result.images?result.images[0]:''
                        this.isVoice = result.isVoice?result.isVoice:false
                        this.source = result.source
                        this.date = result.date.substring(0,10) + ' ' + result.date.substring(11,16)
                        if (result.type === 'video') {
                            result.medias.map(item => {
                                if(item.type === 'video'){
                                     this.poster = item.image
                                 }
                                item.resources.map (opt => {
                                    if (opt.enctype === 'ld') {
                                        this.videoUrl = opt.url
                                    }
                                })
                            })
                        }

                        if (result.type === 'audio') {
                            result.medias.map(item => {
                                item.resources.map ((opt, i) => {
                                    if (i === 0) {
                                        this.audioUrl = opt.url
                                    }
                                })
                            })
                            this.totalTimes = result.medias[0].times;
                        }
                        this.getHotList(result.categoryId,result.articleId)
                        if (this.$route.params.type === 'normal') {
                            this.getComment(result.sysCode, id)
                        }

                        // 原生app 渲染完调用
                        this.appPostMessage('renderFinish')
                    } else {
                         Toast(res.msg)
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        },

        pageUpdate () {
            this.$nextTick(() => {
                this.setContentCSS()
                this.setVideoBtn()
                this.setVideoFun()
                this.setPaperImg()
            })
        },
        getVote(voteId){//获取投票接口
            this.$axios.get(`${intfc_prefix_common}/api/v2/vote/getVoteInfo/32`)
                .then(res=>{
                    if(res.code ==0){
                        this.vodeOption = res.item
                       
                    }
                })
        },
        getHotList (categoryId, excludeId) {
            let hotListUrl=""
            if(this.$route.params.type === 'normal'){
                hotListUrl=`${intfc_prefix_common}/api/v2/articles/hot/list?categoryId=${categoryId}&excludeId=${excludeId}`
            }else if(this.$route.params.type === 'gov'){
                hotListUrl=`${govUrl}/api/v2/articles/hot/list?categoryId=${categoryId}&excludeId=${excludeId}`
            }
            this.$axios.get(hotListUrl)
                .then(res => {
                    const result = res.item || res.data
                    if (res.code === 0) {
                        // console.log('comments:',result);
                        if (result) {
                            this.relvantNewsData = result.map(
                                i => {
                                    let imgArray = i.imageUrl || i.image
                                    if (imgArray) {
                                        if (imgArray.indexOf(",") != -1) {
                                            i.imageUrl = imgArray.split(",");
                                        } else {
                                            i.imageUrl = [imgArray];
                                        }
                                    }
                                    return i;
                                }
                            );
                        }
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        },

        getComment (sysCode, articleId) {
            this.$axios.get(`${intfc_prefix_common}/api/comments/${sysCode}/${articleId}?size=5`)
                .then(res => {
                    const result = res.items
                    if (res.code === 0) {
                        console.log('comments:',result);
                        if (result) {
                            this.comments = result
                            this.comments.map(item => {
                                item.isLike = false
                            })

                            this.handleLikes(this.mockLikes)
                        }else {
                            this.comments = []
                        }
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        },
        // 点赞
        uuid(){
            this.$axios.post(`${intfc_prefix_common}/api/v2/articles/likeArticleOrNot?articleId=${this.$route.params.id}&likeOrNot=1`)
                .then(res => {
                    // console.log(res,'resultresult')
                    this.$forceUpdate();
                    if (res.code === 0) {
                        if(this.isSharePage){
                            console.log(this.uuids,'this.uuids')
                            if(this.uuids){
                                this.likes=res.item
                                this.isLike=true
                            }else{
                                Toast('请登录后再点赞')
                            }
                        }
                        // if (result) {
                        //     this.comments = result
                            // this.comments.map(item => {
                            //     item.isLike = false
                            // })

                        //     this.handleLikes(this.mockLikes)
                        // }else {
                        //     this.comments = []
                        // }
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        },

        setContentCSS () {
            // 处理content内的 图片与视频 样式
            let img = $('.content img')
            let video = $('.content video')
            let p = $('.content p,.content ul,.content ol,.content h1,.content h2,.content h3,.content h4,.content h5,.content h6,.content blockquote')
            let a = $('.content a')
            let imgParent = img.parent()
            let videoParent = video.parent()
            // console.log(img,'img')
            let images = Array.from(img);
            
            if (images && images.length>0) {
                images.map((item, index) => {
                   
                    let img = $(item)
                    let imgUrl = img.attr('src')
                    this.newImages[index]=img.attr('src')
                    // 绑定图片点击事件
                    this.setImageFun(img, index)

                    // if (img.attr('src').indexOf('?') > -1) {
                    //     imgUrl = `${img.attr('src')}&x-oss-process=image/format,webp`
                    // }else {
                    //     imgUrl = `${img.attr('src')}?x-oss-process=image/format,webp`
                    // }
                    img.attr("src",imgUrl)
                    // 懒加载
                    if (!img.attr('data-src')) {
                        this.urls.push(img.attr('src'))
                        img.attr('data-src', imgUrl)
                        // if (index > 1) {
                        //     img.attr('src', require('images/banner_gray.png'))
                        // }
                    }
                    

                })
                // console.log(this.newImages,'new')
            }
            img
                .css('width', '100%')
                .css('height', 'auto')
                .css('display', 'block')
                .css('margin', '0 auto')
                .attr('onerror', require('images/pic_default_common.png'))


            video
                .css('width', '100%')
                .css('height', '5.76rem')
                .css('display', 'block')
                .css('position','absolute')
                .css('top', 0)
                .css('z-index', 1)
                .css('object-fit','')
                .attr('controlsList', 'nodownload')
            p
                .css('margin', '1em 0')
                .css('padding', '0 .4rem')
                .css('font-size','')
                .css('line-height','')
                .css('font-family','')
                .css('overflow','hidden')
            a.css('font-size','')
            // $(imgParent).attr('style', '')
            $(videoParent).attr('style', '')
            $(videoParent).children('.content-button').remove();
            if ($(videoParent).children('video').attr('flag') != '1') {
                $(videoParent)
                    .attr('style', '')
                    .css('margin', '1.33rem .4rem')
                    .css('height', '5.76rem')
                    .css('position','relative')
                    .css('background', '#000')
                    .append('<button class="content-button"></button>')
            }
        },

        setVideoBtn () {
            // 设置video按钮 点击播放
            const _this = this
            $('button').click(function () {
                if (!navigator.onLine) {
                    Toast({
                        message: '网络连接失败，请稍后再试',
                        position: 'bottom'
                    })
                }else {
                    let video = $(this).prev()
                    // if (!_this.isSharePage) {
                    //     // 由app客户端调用视频
                    //     let videoData = {
                    //         url: video.attr('src'),
                    //         image: video.attr('poster'),
                    //         size: video.attr('size')
                    //     }  
                    //     _this.appPostMessage('playVideo', JSON.stringify(videoData))
                    // } else {
                    //     video[0].play()
                    // }
                    video[0].play()
                }
            })
        },

        setVideoFun () {
            // 配置video 悬浮逻辑
            const _this = this
            let md = $(".content video")
            let topVideo = $(".video-wrap video")
            let arg = Array.from(md);
            arg.map((item, index) => {
                item.addEventListener("pause",function(){
                    setTimeout(() => {
                        
                        if (item.paused) {
                            let father = $(item).parent()
                            father
                                .css('position', 'relative')
                            $(item)
                                .css('position', 'absolute')
                                .css('z-index', 1)

                            if (_this.el === item) _this.el = null
                        }
                    },100)
                })

                item.addEventListener("ended",function(){
                    setTimeout(() => {
                        if (item.ended) {
                            let father = $(item).parent()
                            father
                                .css('position', 'relative')
                                .append('<button class="content-button"></button>')

                            if ($(item).attr('poster')) {
                                father.append('<img class="poster" src="'+$(item).attr('poster')+'" />')
                            }

                            $(item)
                                .css('position', 'absolute')
                                .css('z-index', 1)
                                .removeAttr('controls')
                            $(father.children('.content-button')).click(function () {
                                let video = $(this).prev()
                                video[0].play()
                            })
                            // item.load()
                            if (_this.el === item) _this.el = null
                        }
                    },100)
                })

                item.addEventListener("playing",function(){
                   
                    let obj=JSON.stringify({
                        width:$(item).attr('data-width'),
                         height:$(item).attr('data-height')
                    })
                   console.log(obj,'obj')
                     _this.appPostMessage('toVideoSize',JSON.stringify({
                         width:$(item).attr('data-width'),
                         height:$(item).attr('data-height'),
                     }))
                    _this.pauseVideo(item)
                    // 暂停朗读
                    _this.appPostMessage('pauseAudio')
                    let btn = $(item).next()
                    btn.remove()
                    let videoParent = $(item).parent()
                    $(videoParent).children('.poster').remove();
                    $(item).attr('controls', 'controls')

                    _this.el = item

                    _this.saveVideo = item
                    _this.appPostMessage('getNetState')
                })

                let videoInfo  = _this.data.moreVideos[index]
                $(item).attr('size',videoInfo.video.size)
            })

            if (topVideo && topVideo.length > 0) {
                topVideo[0].addEventListener("pause",function(){
                    // console.log("暂停");
                })

                topVideo[0].addEventListener("ended",function(){
                    
                    let father = $(this).parent()
                    father
                        .append('<button class="content-button"></button>')
                    if ($(this).attr('poster')) {
                        father.append('<img class="poster" src="'+$(this).attr('poster')+'" />')
                    }
                    $(this)
                        .removeAttr('controls')

                    $(father.children('.content-button')).click(function () {
                        let video = $(this).prev()
                        video[0].play()
                    })
                })
                let topVideoInfo  = _this.data.medias[0]
                let obj = topVideoInfo.resources[0]
                console.log(obj,'obj')
                topVideo.attr('size',obj.size)

                topVideo[0].addEventListener("playing",function(){
                   
                    let objVideo=JSON.stringify({
                        width:_this.data.medias[0].resources[0].width,
                        height:_this.data.medias[0].resources[0].height,
                    })
                    console.log(objVideo,'obj')
                    _this.appPostMessage('toVideoSize',objVideo)
                    _this.pauseVideo(this)
                    _this.el = null
                    // 暂停朗读
                    _this.appPostMessage('pauseAudio')
                    let btn = $(this).next()
                    btn.remove()
                    let videoParent = $(this).parent()
                    $(videoParent).children('.poster').remove();
                    $(this).attr('controls', 'controls')

                    _this.saveVideo = this
                    _this.appPostMessage('getNetState')
                })

                

                // 顶部视频16:9
                let dpr = window.devicePixelRatio
                let u = navigator.userAgent;
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isiOS && !this.isPreviewPage) {
                    topVideo.css('height', (window.screen.width*dpr / 16 * 9) + 'px' )
                    $(".video-wrap").css('height', (window.screen.width*dpr / 16 * 9) + 'px' )
                    // $(".video-mask").css('height', (window.screen.width*dpr / 16 * 9) + 'px' )
                }else if (!this.isPreviewPage){
                    topVideo.css('height', (window.screen.width / 16 * 9) + 'px' )
                    $(".video-wrap").css('height', (window.screen.width / 16 * 9) + 'px' )
                    // $(".video-mask").css('height', (window.screen.width / 16 * 9) + 'px' )
                }
            }
        },

        pauseVideo (act) {
            let video = $('video')
            let videoArr = Array.from(video);
            videoArr.map((item,index) => {
                if (!item.paused && act !== item) {
                    item.pause()
                }
            })
        },

        setImageFun (img, index) {
            let _this = this
            // 图片 绑定点击事件，调用app图集
            img.off("click").on("click", () => {
                if(this.isSharePage){
                    this.showLargeImage=true
                    this.showLargeIndex=index
                    //this.mySwiper.slideTo(index, 1000, false);//切换到第一个slide，速度为1秒
                }else{
                    this.showLargeImage=false
                    if (this.picFlag) {
                        this.picFlag = false
                        this.pauseAllVideo()
                        let obj = JSON.stringify({ position: index, urls: _this.urls })
                        this.appPostMessage('checkBigPic', obj)
                        setTimeout(() => {
                            this.picFlag = true
                        }, 500)
                    }
                }
                
            })
        },

        pauseAllVideo () {
            let video = $('video')
            let videoArr = Array.from(video);
            videoArr.map((item,index) => {
                if (!item.paused) {
                    item.pause()
                }
            })
        },

        setPaperImg () {
            // images 绑定图片点击事件
            let images = Array.from($('.images img'));
            images.map((item, index) => {
                console.log(this.mySwiper,"setPagerImg")
                this.setImageFun($(item), index)
            })
        },

        lazyLoad() {
            // 图片懒加载
            let height = document.documentElement.clientHeight;
            // console.log(this.images)
            this.images.map(item => {
                if (item.getBoundingClientRect().top < height) {
                    if (this.CheckImgExists($(item).attr("data-src"))) {
                        $(item).attr("src", $(item).attr("data-src"));
                    }else{
                        // $(item).attr("src", $(item).attr("onerror"));
                    }
                }
            });
        },

        // getTopVideo () {
        //     let videoWrap = $('.video-wrap')

        //     if (this.isSharePage && this.$refs.videoWrap) {
        //         if (parseInt(this.$refs.videoWrap.getBoundingClientRect().top)<0) {
        //             videoWrap.css('position', 'fixed').css('top', 0)
        //         }else {
        //             videoWrap.css('position', 'absolute').css('top', '')
        //         }
        //     }else {
        //         videoWrap.css('position', 'fixed').css('top', 0)
        //     }
        // },

        appPostMessage (name, value='') {
            // 调用app原生方法
            if (name) window.appapi.appPostMessage(name, value)
        },

        getTime (time) {
            let result = ''
            if (time) {
                result = time.substring(0,10) + ' ' + time.substring(11,16)
            }
            return result
        },

        getLikesCount (count) {
            let result = ''
            if (count > 0) {
                let strTel = count.toString();
                result = count
                if (count > 999999) {
                    result = strTel.substring(0,strTel.length - 4) + '万'
                    if (count > 99999999) {
                        result = '过亿'
                    }
                }
            }
            return result
        },

        handleLikes (arr) {
            if (arr && arr.length > 0) {
                this.mockLikes = arr
                this.mockLikes.map((item) => {
                    this.$forceUpdate();
                    this.comments.map((option) => {
                        if (item === option.id) {
                            option.isLike = true
                        }
                    })
                })
            }
        },

        setActiveLike (opt) {
            if (this.isSharePage || !opt.id) return
            this.$forceUpdate();
            if (!opt.isLike) {
                this.appPostMessage('phraise',JSON.stringify(opt))
                this.comments.map((option) => {
                    if (opt.id === option.id) {
                        option.isLike = true
                        option.likes += 1
                        // console.log(option.likes,'option.likes')
                    }
                })
            }
        },

        addComment (item) {
            if (!item.id) return
            this.appPostMessage('comment',JSON.stringify(item))
        },
        CheckImgExists(imgurl) {
            let ImgObj = new Image(); //判断图片是否存在
            ImgObj.src = imgurl;
            //没有图片，则返回-1
            if (
                ImgObj.fileSize > 0 ||
                (ImgObj.width > 0 && ImgObj.height > 0)
            ) {
                return true;
            } else {
                return false;
            }
        }
	},

    components: {
        PageCommon,
        List,
        audioBar,
        PageVote,
    }
}

</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import "~src/stylus/mixin";
    .content-button 
        margin: 0 0 -50px -50px;
    .wrapper
        position relative
        font-family: 'FZBIAOYSK','FZBIAOYSKIOS','FZBIAOYSKIOS BOLD','PingFang SC', '微软雅黑', sans-serif;
        .top-pic
            width 750px
            max-height 400px
            overflow hidden
            img
                display block
        video, audio
            width 100%
        .video-wrap
            position relative
            width 100%
            z-index 1000
            height 400px
            background #000
            padding:0 0.4rem
            background-clip:content-box
            box-sizing: border-box
            video
                height 400px
        .video-mask
            position fixed
            top 0
            width 100%
            z-index 1000
            height 400px
            background #000
        .box-block
            height 400px
        .essay
            margin-top 20px
            padding 0 30px
            h1
                font-weight normal
                font-size 44px
                line-height 68px
            h3
                font-weight normal
                line-height 40px
                margin 0 0 20px
                font-size 28px
                color #686868
            .desc
                color #222
                font-size 28px
                line-height 42px
                margin 20px 0 0
            .date-wrap
                margin-top 44px
            .date
                font-size 24px
                color #AFAFAF
            .recite
                margin-right 20px
                width 72px
                height 72px
                background url("~images/recite.png") no-repeat 50% 50%
                background-size .9rem
            .gov-info,
            .category-info
                margin-top 44px
                height 84px
                padding 20px
                background #F6F6F6
                .avatar 
                    width 80px
                    height 80px
                    background #FDE0E2 url("~images/avatar_jinguan.png") no-repeat 0 0/100% 100%
                    border-radius 999px
                    flex none
                .info 
                    margin-left 18px
                    h5 
                        color #000 
                        font-size 28px
                        line-height 50px
                    .title-icon
                        display block
                        flex 0 0 70px
                        text-align center     
                        margin-left 20px
                        padding 0 0
                        height 32px
                        line-height 32px
                        font-size 20px
                        font-weight normal
                        color #E02829
                        background-color #FFDDDE
                        border-radius 4px
                        white-space nowrap
                    .date
                        line-height 30px
                        max-height 60px
                        font-size 24px
                        color #AFAFAF
                .follow-btn
                    width 144px
                    height 50px
                    border-radius 25px
                    // background #F87650
                    border 2px solid #E02829
                    text-align center
                    color #E02829
                    font-size 26px
                    line-height 50px
                    flex 0 0 144px
                .no 
                    background #EEF2F3
                    border-color #EEF2F3
                    color #9293A3
            .gov-info>div
                flex: 1 1 auto;        
            .gov-info .info
                flex: 1 1 auto; 
                h5
                    display flex
                    align-items center
                    
        .images
            margin-top 100px
            li
                margin 20px 0
                img
                   width 100%
                   height auto
        .content
            margin-top 50px
            text-align justify
            line-height 64px
            // line-height 1.8em
            word-break break-word
            button
                position absolute
                left 0
                bottom 5px
                width 140px
                height 100px
                background rgba(64,120,255,0.95)
                z-index 998
            button:after
                content ''
                display:block;
                width:0;
                height:0;
                border-width:14px 0 14px 18px;
                border-style:solid;
                border-color:transparent transparent transparent #fff
                position:absolute;
                top 50%
                left 50%
                margin -12px 0 0 -8px
        .content-footer
            text-align justify
            line-height 64px
            background #fff url("~images/content-footer@3x.png") no-repeat center bottom/100% auto
            padding-bottom 142px
        .article-desc    
            padding 0 30px
            //font-size 30px
            font-size 24px
            //color #757575
            color #666
            line-height 54px
        .active-good
            background:#D4282B;
        .uuidLikes
            width: 326px;
            height: 92px;
            border: 2px solid #D4282B;
            border-radius: .62rem; 
            text-align: center;
            font-size: 32px;
            color: #D4282B;
            line-height:96px;
            margin:60px auto;
            justify-content: center;
            i
                display:inline-block
                width 48px
                height 48px
                background no-repeat 50%/100%
                margin-right 10px
            .active-good
                background-image url("~images/btn_likes2x.png")
            .good
                background-image url("~images/btn_gooded2x.png")
                
            .active-num
                color:#fff
            span
                display block
                margin-top 8px
        .relevant-news
            margin-top 80px
            .title  
                padding 0 30px         
                font-size 40px
                color #222
                line-height 48px
        .comment
            padding 30px
            .title
                span
                    // margin-left 20px
                    color #222
                    font-size 32px
                    // font-weight bold
                i
                    display inline-block
                    width 36px
                    height 36px
                    // background url("~images/icon_Quotes.png") no-repeat 50%/100%
                    background url("~images/icon_details_hot@2x.png") no-repeat 50%/100%
            ul
                margin-top 88px
                li
                    header
                        display flex
                        .avatar
                            width 70px
                            height 70px
                            border-radius 999px
                            background no-repeat 50%/100%
                        .info-area
                            max-width 460px
                            height 70px
                            text-indent 20px
                            .name
                                //color #858585
                                color #222
                                font-size 28px
                                line-height 40px
                            .time
                                //color #AFAFAF
                                color #666
                                font-size 20px
                                line-height 34px
                        .like
                            height 70px
                            i
                                width 48px
                                height 48px
                                background no-repeat 50%/100%
                            .good
                                background-image url("~images/btn_good2x.png")
                            .active-good
                                background-image url("~images/btn_gooded2x.png")
                            span
                                margin-right 8px
                                font-size 24px
                            .num
                                color #222
                            .active-num
                                color #E02829
                    section
                        margin-top 16px
                        p
                            overflow hidden
                            word-break break-word
                            line-height 64px
                            font-size 32px
                            color #000
                li:not(:first-of-type)
                    margin-top 94px

            .check-all
                margin-top 98px
                padding-bottom 90px
                color #E02829
                font-size 30px
                line-height 40px
                // justify-content center
                text-align center
                i
                    display inline-block
                    width 40px
                    height 40px
                    background url("~images/more.png") no-repeat 50%/100%
                    vertical-align -8px
                    margin-left -10px
            .origin
                margin-top 14px
                padding 24px 22px
                background #F6F6F6
                .origin-info
                    .origin-name
                        // font-weight bold
                        font-size 28px
                        //color #858585
                        color #666
                    .origin-time
                        color #AFAFAF
                        font-size 24px
                .origin-content
                    margin-top 14px
                    font-size 30px
                    //color #9B9B9B
                    color #666
                    line-height 42px
                    text-align justify
                    overflow hidden
                    word-break break-word
            .no-comment
                margin 40px auto 0
                width 560px
                height 560px
                background url("~images/no-comment.png") no-repeat 50%/100%
    .largeSwiper
        position: fixed;
        z-index: 998;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        .viewSwiper
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: rgba(0,0,0,0.85);
        .swiper-container
            position: fixed;
            top: 50%;
            left: 50%;
            width: 100%;
            overflow: hidden;
            font-size: 16px;
            -webkit-transform: translate3d(-50%, -50%, 0);
            transform: translate3d(-50%, -50%, 0);
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-transition: 0.3s;
            transition: 0.3s;
            -webkit-transition-property: opacity, -webkit-transform;
            transition-property: opacity, -webkit-transform;
            transition-property: transform, opacity;
            transition-property: transform, opacity, -webkit-transform;
            height 100%;
        .swiper-wrapper
            align-items: center;
            width:100%;
            height 100% !important;
            .swiper-slide
                display: flex;
                justify-content: center;
                align-items: center;
                img
                    max-height 100vh !important;
                    max-width:100%;
        .swiper-pagination
            color: #fff;
            position: absolute;
            bottom: 0.533333rem;
            left: 0.5rem;
            text-align: left;
            background: red;
            display: inline-block;
            width: 100px;
            height: 40px;
            text-align: center;
            line-height:40px;

</style>


// WEBPACK FOOTER //
// page-detail.vue?c6ff7b56